/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdsDisconnectedDeploymentAllOfDisconnectedModeProperties { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Component Version
     */
    component_version?: string;
    /**
     * encrypted hash value of deactivation code
     */
    deactivation_code?: string;
    /**
     * Resource FQDN
     */
    fqdn?: string;
    quantity?: number;
    sequence_number?: number;
    /**
     * Updated by user
     */
    update_by?: string;
    /**
     * Provider ID in format: <res-type>-<res-id>
     */
    vcenter_id?: string;
}

